/* ---- DOM manipulation ---- */
/* shared DOM elements */
const addressInfo = JSON.parse(localStorage.getItem('addressInfo'));
const emailLine = document.getElementById('trade-in-shipping__contact__email');
const address1Line = document.getElementById('trade-in-shipping__address__1');
const address2Line = document.getElementById('trade-in-shipping__address__2');
const contactChangeBtn = document.querySelector('.trade-in-shipping__contact_change');
const addressChangeBtn = document.querySelector('.trade-in-shipping__address_change');
const submitBtn = document.getElementById('confirmation-submit-btn');

/* return DOM elements */
const yesReturn = document.getElementById('trade-in-shipping__yes_return');
const noReturn = document.getElementById('trade-in-shipping__no_return');
const isReturnPage = !!yesReturn;

/* review DOM elements */
const sendbackItem = JSON.parse(localStorage.getItem('sendbackItem'));
const returnOptInChangeBtn = document.querySelector('.trade-in-shipping__return_change');
const returnOptInLine = document.getElementById('trade-in-shipping__return-opt-in');
const isReviewPage = !global.useSendbackOptIn || !!returnOptInLine;

/* required confirmation checkboxes */
const requiredConfirmations = document.querySelectorAll('.confirmation-checkbox__required');

const checkRequiredConfirmations = () => {
  const requiredConfirmed = Array.from(requiredConfirmations).every(rc => rc.checked);
  submitBtn.disabled = !requiredConfirmed;
}

/* ---- Functions ---- */
const renderAddressInfo = () => {
  emailLine.textContent = addressInfo.email;
  address1Line.textContent = `${addressInfo.address1}${addressInfo.address2?.length ? `, ${addressInfo.address2}` : ''}`;
  address2Line.textContent = `${addressInfo.city}, ${addressInfo.state}, ${addressInfo.postalCode}`;
}

const renderSendbackInfo = () => {
  const {
    sendbackOptInNo,
    sendbackOptInYes,
  } = TRADE_IN_SHIPPING_RETURN_REVIEW_CONFIG;
  returnOptInLine.textContent = sendbackItem ? sendbackOptInYes : sendbackOptInNo;
};

const selectOption = (option) => {
  localStorage.setItem('sendbackItem', option === 'yesReturn');
  submitBtn.disabled = false;
}

const cleanUpLocalStorage = () => {
  localStorage.removeItem('addressInfo');
  localStorage.removeItem('sendbackItem');
  localStorage.removeItem('tradeinUuid');
}

/* ---- Event Listeners ---- */
/* shared */
contactChangeBtn.addEventListener('click', () => {
  window.location = appendReferrerToUrl(`${Shopify.routes.root}pages/trade-in-shipping-2`);
});
addressChangeBtn.addEventListener('click', () => {
  window.location = appendReferrerToUrl(`${Shopify.routes.root}pages/trade-in-shipping-2`);
});
submitBtn.addEventListener('click', async () => {
  if (isReturnPage) {
    window.location = appendReferrerToUrl(`${Shopify.routes.root}pages/trade-in-shipping-review`);
  } else {
    const tradeinUuid = localStorage.getItem('tradeinUuid');
    await submitTradeIn({ tradeinUuid, isSendbackOptIn: sendbackItem, ...addressInfo });
    cleanUpLocalStorage();
    const tradeInConfirmationPathname = `${window.location.pathname.match(/.*pages/i)[0]}/trade-in-confirmation-2`;
    if (!Shopify.designMode) {
      window.location.href = appendReferrerToUrl(`${tradeInConfirmationPathname}?tradeinuuid=${tradeinUuid}`);
    }
  }
});

/* return */
if (isReturnPage) {
  yesReturn.addEventListener('click', () => selectOption('yesReturn'));
  noReturn.addEventListener('click', () => selectOption('noReturn'));
}

/* review */
if (isReviewPage) {
  if (global.useSendbackOptIn) {
    returnOptInChangeBtn.addEventListener('click', () => {
      window.location = appendReferrerToUrl(`${Shopify.routes.root}pages/trade-in-shipping-return`);
    });
  }

  requiredConfirmations.forEach(requiredConfirmation => {
    requiredConfirmation.addEventListener('change', checkRequiredConfirmations);
  });

  checkRequiredConfirmations();
}

renderAddressInfo();
if (isReviewPage && global.useSendbackOptIn) {
  renderSendbackInfo();
}
else {
  if (sendbackItem) {
    yesReturn.click();
  } else if (sendbackItem === false) {
    noReturn.click();
  }
}

renderShippingCart();
